import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '../UI/SectionHeading';
import { WHY_ME } from '../../constants';

const WhyMe: React.FC = () => {
  return (
    <section id='why' className='scroll-mt-20 max-w-7xl mx-auto px-5 sm:px-6'>
      <SectionHeading
        index='02'
        kicker='Why Me'
        title='Less handoff, more ownership'
        description='What an embedded analyst-builder changes for a transformation program.'
      />

      <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-line'>
        {WHY_ME.map((item, i) => (
          <motion.div
            key={item.title}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-50px' }}
            transition={{ duration: 0.55, delay: (i % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
            className='group relative border-r border-b border-line p-7 sm:p-8 min-h-[210px] flex flex-col transition-colors duration-500 hover:bg-surface'
          >
            <span className='label-mono text-gray2 group-hover:text-accent transition-colors duration-300'>
              {String(i + 1).padStart(2, '0')}
            </span>
            <h3 className='mt-auto pt-8 font-medium tracking-tight text-lg text-ink'>
              {item.title}
            </h3>
            <p className='mt-2.5 text-sm leading-relaxed text-gray1'>{item.description}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default WhyMe;
